import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type { Root } from 'react-dom/client';

import type { VisitDebugWorkflowModel } from './route';

export default class VisitorsVisitDebugWorkflowController extends Controller {
  @service declare reactRenderer: ReactRendererService;

  declare model: VisitDebugWorkflowModel;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { WorkflowDebugPage } = await import('reactRichComponents/visitors/WorkflowDebugPage');
    if (this.isDestroying || this.isDestroyed) return;

    this.root = await this.reactRenderer.render(WorkflowDebugPage, 'react__workflow-debug-page', {
      visitableId: this.model.visitableId,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
